import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { truncateText } from 'helpers/ContentHelper';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import useBreakpoint from 'hooks/useBreakpoint';
import style from './Description.module.scss';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    maxChars: 400,
  },
  [SITE_PLATFORM_WEB]: {
    maxChars: 400,
  },
  [SITE_PLATFORM_TABLET]: {
    maxChars: 200,
  },
  [SITE_PLATFORM_MOBILE]: {
    maxChars: 80,
  },
};

const Description = ({
  disableScroll = () => {},
  episode = {},
  isAnonymous = false,
  item = {},
  theme,
  toggleModal,
}) => {
  const breakpoint = useBreakpoint();

  const { description = '', shortDescription = '', longDescription = '' } = episode.percentWatched
    ? episode
    : item;

  const { global_moreButton: moreButtonLabel } = window.Language;

  const readMoreClickHandler = e => {
    e.preventDefault();
    e.stopPropagation();
    toggleModal(true);
    disableScroll({ disableScroll: true, bodyOnly: true, fixedPosition: true });
  };

  const selectedShortDescription = shortDescription || description || longDescription;

  const { maxChars } = BREAKPOINTS[breakpoint];
  const isLong = selectedShortDescription.length > maxChars;
  const truncatedDescription = isAnonymous
    ? longDescription
    : truncateText(selectedShortDescription, maxChars);
  const readMore =
    isLong && !isAnonymous ? (
      <button
        className={classNames(style.readMore, theme.readMore)}
        onClick={readMoreClickHandler}
        type="button"
        aria-label={moreButtonLabel}
      >
        {moreButtonLabel}
      </button>
    ) : null;

  return (
    <div className={classNames(style.description, theme.description)}>
      {truncatedDescription}
      {readMore}
    </div>
  );
};

Description.propTypes = {
  item: PropTypes.shape({}).isRequired,
  isAnonymous: PropTypes.bool,
  episode: PropTypes.shape({}),
  disableScroll: PropTypes.func,
  theme: PropTypes.shape({}),
  toggleModal: PropTypes.func,
};
export default Description;
